import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { Pill } from './Atoms';
import { fonts } from '../theme';

const NAV = [
  { label: 'About', path: '/about' },
  { label: 'Care', path: '/services' },
  { label: 'Booking', path: '/book' },
  { label: 'Contact', path: '/contact' },
];

export default function DesktopHeader({ t }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      padding: '24px max(56px, 4vw)', borderBottom: `0.5px solid ${t.hair}`,
      maxWidth: 1440, margin: '0 auto', width: '100%',
    }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{
          width: 32, height: 32, borderRadius: 999, background: t.ink, color: t.paper,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: fonts.serif, fontSize: 16, fontStyle: 'italic',
        }}>m</div>
        <div style={{ fontFamily: fonts.serif, fontSize: 17 }}>
          Dr. Moksha Patel{' '}
          <span style={{ color: t.muted, fontFamily: fonts.mono, fontSize: 11, letterSpacing: '0.04em' }}>
            (PT)
          </span>
        </div>
      </Link>
      <nav style={{ display: 'flex', gap: 32, fontSize: 13 }}>
        {NAV.map(n => {
          const active = pathname === n.path;
          return (
            <Link
              key={n.label}
              to={n.path}
              style={{
                cursor: 'pointer',
                color: active ? t.ink : t.muted,
                fontWeight: active ? 600 : 400,
              }}
            >
              {n.label}
            </Link>
          );
        })}
      </nav>
      <Pill t={t} icon="calendar" fill={t.ink} ink={t.paper} onClick={() => navigate('/book')}>
        Book a session
      </Pill>
    </div>
  );
}
